/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ page: NonNullable<unknown> }} Settings_Files_Pagination_PageInputs */

const es_settings_files_pagination_page = /** @type {(inputs: Settings_Files_Pagination_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Página ${i?.page}`)
};

const en_settings_files_pagination_page = /** @type {(inputs: Settings_Files_Pagination_PageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Page ${i?.page}`)
};

/**
* | output |
* | --- |
* | "Page {page}" |
*
* @param {Settings_Files_Pagination_PageInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_pagination_page = /** @type {((inputs: Settings_Files_Pagination_PageInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Pagination_PageInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_pagination_page(inputs)
	return en_settings_files_pagination_page(inputs)
});
export { settings_files_pagination_page as "settings.files.pagination.page" }